import { createAction, props } from '@ngrx/store';
import { IEmployeeBankDetailResponse } from '../models/employee-bank-detail.model';

export const loadBankList = createAction('[BankList] Load BankList', props<{ customerId: string }>());

export const loadBankListSuccess = createAction(
  '[BankList] Load BankList Success',
  props<{ response: IEmployeeBankDetailResponse[] }>()
);

export const loadBankListFailure = createAction('[BankList] Load BankList Failure', props<{ error: Error | any }>());
